<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">طلبات الصيانة المتأخرة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">طلبات الصيانة المتأخرة</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <div class="container-fluid">
        <!-- filter -->
        <div class="row mt-2">
          <div class="col">
            <form @submit.prevent="filterResults">
              <div class="card card-warning card-outline">
                <div class="card-header"><div class="card-title">بحث وتصفية</div></div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <select class="form-control" v-model="searchTypes">
                        <option :value="null">نوع الطلب</option>
                        <option value="normal">{{ orderTypes['normal'] || 'عادي' }}</option>
                        <option value="fast">{{ orderTypes['fast'] || 'سريع' }}</option>
                      </select>
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <input type="number" v-model="searchOrderId" class="form-control" placeholder="رقم الطلب">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <input type="text" v-model="searchClientMobile" class="form-control" placeholder="جوال العميل">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <input type="text" v-model="searchProviderMobile" class="form-control" placeholder="جوال المزود">
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="row">
                    <div class="col text-end">
                      <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button>
                      <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- table -->
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-4">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">الطلبات المتأخرة</div>
                <span v-if="countRows > 0" class="badge rounded-pill bg-danger fs-6 px-3 py-2 ms-auto">
                  عدد النتائج ( {{ countRows }} )</span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>نوع الطلب</th>
                            <th>العميل</th>
                            <th>المزود</th>
                            <th>الخدمة</th>
                            <th>الحالة</th>
                            <th>تاريخ الإنشاء</th>
                            <th>وقت الوصول</th>
                            <th>مدة التأخير</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>
                              <span class="badge" :class="row.orderType == 'fast' ? 'bg-danger' : 'bg-secondary'">
                                {{ orderTypes[row.orderType] }}
                              </span>
                            </td>
                            <td>{{ (row.User)? row.User.name : 'غير معروف' }}<br/>{{ (row.User)? row.User.mobile : 'غير معروف' }}</td>
                            <td>
                              {{ (row.Provider)? row.Provider.name : 'لا يوجد' }}
                              <div v-if="row.Provider">{{ row.Provider.mobile }}</div>
                            </td>
                            <td>{{ (row.MaintenanceIssue)? row.MaintenanceIssue.name : 'غير معروف' }}</td>
                            <td>{{ orderStatus[row.status] }}</td>
                            <td>{{ $shortDate(row.createdAt) }}</td>
                            <td>{{ (row.arriveTime)? $shortDate(row.arriveTime) : 'لم يصل بعد' }}</td>
                            <td class="text-danger fw-bold">{{ delayText(row) }}</td>
                            <td>
                              <router-link :to="`/orders/update/${row.id}`" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('maintenance_orders_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';

export default {
  name: 'OrdersDelayedList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      countRows: 0,
      orderTypes: {},
      orderStatus: {},
      searchTypes: this.$route.query.types || null,
      searchOrderId: this.$route.query.orderId || null,
      searchClientMobile: this.$route.query.cMobile || '',
      searchProviderMobile: this.$route.query.pMobile || '',
    }
  },
  methods: {
    checkAccess,
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      let urlQuery = [`page=${this.currentPage}`];
      if(this.searchTypes)
        urlQuery.push(`orderType=${this.searchTypes}`);
      if(this.searchOrderId)
        urlQuery.push(`id=${this.searchOrderId}`);
      if(this.searchClientMobile.trim() != '')
        urlQuery.push(`cMobile=${this.searchClientMobile.trim()}`);
      if(this.searchProviderMobile.trim() != '')
        urlQuery.push(`pMobile=${this.searchProviderMobile.trim()}`);

      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchTypes ? { types: this.searchTypes } : {}),
        ...(this.searchOrderId ? { orderId: this.searchOrderId } : {}),
        ...(this.searchClientMobile ? { cMobile: this.searchClientMobile } : {}),
        ...(this.searchProviderMobile ? { pMobile: this.searchProviderMobile } : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/orders/delayedList?${urlQuery.join('&')}`).then(({data}) => {
        this.rows = data.rows;
        this.orderTypes = data.orderTypes;
        this.orderStatus = data.orderStatus;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.mainLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    delayText(row){
      const created = new Date(row.createdAt);
      const end = row.arriveTime ? new Date(row.arriveTime) : new Date();
      const limitMs = (row.orderType === 'fast') ? 120 * 60 * 1000 : 24 * 60 * 60 * 1000;
      const delayMs = (end - created) - limitMs;
      if(delayMs <= 0) return '-';
      const totalMins = Math.floor(delayMs / 60000);
      const days = Math.floor(totalMins / 1440);
      const hours = Math.floor((totalMins % 1440) / 60);
      const mins = totalMins % 60;
      if(days > 0) return `${days} يوم و ${hours} ساعة`;
      if(hours > 0) return `${hours} ساعة و ${mins} دقيقة`;
      return `${mins} دقيقة`;
    },
    filterResults(){
      this.currentPage = 1;
      this.getList();
    },
    clearFilter(){
      this.searchTypes = null;
      this.searchOrderId = null;
      this.searchClientMobile = '';
      this.searchProviderMobile = '';
      this.currentPage = 1;
      this.getList();
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(page){
      this.currentPage = page;
      this.getList();
    },
  },
  mounted(){
    this.getList();
  }
}
</script>